import { render } from "./SecretForm.vue?vue&type=template&id=2af8212e&ts=true"
import script from "./SecretForm.vue?vue&type=script&lang=ts"
export * from "./SecretForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__